$(function () {

    $('.moment-element-detail-modal .next').on('click', function (e) {

        e.preventDefault();

        $this = $(this);
        $modal = $this.closest('.moment-element-detail-modal');

        $target = $modal.next('.moment-element-detail-modal');
        if (!$target.length) {
            $target = $('.moment-element-detail-modal').first();
        }

        $modal.addClass('left');
        $target.addClass('notransition')
            .removeClass('left')
            .addClass('right')
            .delay(10)
            .queue(function () {
                $(this)
                    .removeClass('notransition')
                    .removeClass('right')
                    .dequeue();
            });

    });

    $('.moment-element-detail-modal .prev').on('click', function (e) {

        e.preventDefault();

        $this = $(this);
        $modal = $this.closest('.moment-element-detail-modal');

        $target = $modal.prev('.moment-element-detail-modal');
        if (!$target.length) {
            $target = $('.moment-element-detail-modal').last();
        }

        $modal.addClass('right');
        $target.addClass('notransition')
            .removeClass('right')
            .addClass('left')
            .delay(10)
            .queue(function () {
                $(this)
                    .removeClass('notransition')
                    .removeClass('left')
                    .dequeue();
            });

    });

    // $('.moment-detail-show-more, .moment-detail-hide-more').on('click', function (e) {
    //     e.preventDefault();
    //
    //     $this = $(this);
    //
    //     $this.closest('.moment-element-detail-expanding').toggleClass('expanded');
    // });

    $('.breakdown > .spreadline-wrapper').on('click', function (e) {
        e.preventDefault();
        var $target = $(this).next('.spreadlines-nested');

        if ($target.is(':hidden')) {
            $target.find('line').each(function () {
                $line = $(this);
                $a = $line.find('animate').remove().clone();
                $line.append($a);
            });
        }

        $target.slideToggle('fast');


        $target.find('animate').map((i, e) => {
            // removing the animation elements and re-adding appears to be a good idea here.
            // they need cloning, or they re-add in completed state
            // they still need beginElementAt called for them to work


            e.beginElementAt(0.2);
        });
    });

    $(document).on('click', '.moment-modal-trigger', function (e) {
        e.preventDefault();
        $('#swipe')[0].play();
        var modalid = $(this).attr('data');
        $(document).find('#modals').addClass('active').addClass('semi-opaque');
        $(document).find('#' + modalid).removeClass('left right');
    });

    $(document).on('click', '.moment-element-detail-modal .close', function () {
        $('#swipe')[0].play();
        $(this).closest('#modals').removeClass('semi-opaque').find('.moment-element-detail-modal').addClass('right').delay(250)
            .queue(function () {
                $(document).find('#modals').removeClass('active');
                $(this).dequeue();
            });

    });

    if ($('.moment-result-filters select[multiple]').length) {
        $('.moment-result-filters select[multiple]').select2({
            placeholder: 'Please select...',
            width: '100%',
        });
    }

    if ($('#filter_toggle').length) {
        $('#filter_toggle').on('click', function (e) {
            e.preventDefault();
            $('#filter_toggle').parent().toggleClass('activated');
        });
    }
});
